module.exports = __webpack_public_path__ + "img/slide17_vn.a641cfad.jpg";